/**
 * FHIR extension URLs and constants for the Settings → Practices & Users
 * admin directory (Organization / Practitioner / Patient).
 *
 * These extend the base RBAC extension set in features/rbac/constants.ts.
 */

export const ADMIN_EXTENSION_URLS = {
  /** Links a Practitioner or Patient to their practice Organization. */
  organization: 'https://unify.health/fhir/organization',
  /** Links an Organization to its owner Practitioner. */
  practiceOwner: 'https://unify.health/fhir/practice-owner',
} as const;
